/* TRS Bundle Builder — v3, 13-08-2026. One layout: vanity with an insert basin.
   v4, 14-08-2026. The paid mirror-cabinet add-on is removed: every vanity in
   bundle-vanity-basin already ships with a mirror cabinet, so the add-on was
   selling a duplicate. SAVE_KEY is deliberately NOT bumped — a stored v2 build
   holds picks for these same eight slots and is still valid; its now-unused
   `addon` key is simply never read. */
(function () {
  var root = document.querySelector('[data-trsbb]');
  if (!root) return;

  /* Marks the page for stylesheet rules that must reach elements outside this
     section, such as the chat widget the theme appends straight to <body>. */
  document.documentElement.classList.add('trsbb-page');

  var VARIANT = root.dataset.variant;
  var FIXED = parseFloat(root.dataset.price) || 1699;

  /* The vanity slot is deliberately narrow: a short curated set of cabinets that
     already have the basin AND the mirror cabinet included, not the full vanity
     catalogue. There is no separate basin, vanity-top or mirror slot any more. */
  var SRC = {
    toilet: 'toilet-bowl', vanity: 'bundle-vanity-basin',
    tap: 'basin-faucet', shower: 'rain-shower', bidet: 'bidet',
    acc: 'bathroom-accessories'
  };

  var ACC = [
    { k: 'acc1', cat: 'Accessory 1', src: 'acc' },
    { k: 'acc2', cat: 'Accessory 2', src: 'acc' },
    { k: 'acc3', cat: 'Accessory 3', src: 'acc' }
  ];
  var TAIL = [
    { k: 'tap', cat: 'Basin Tap', src: 'tap' },
    { k: 'shower', cat: 'Rainshower', src: 'shower' },
    { k: 'bidet', cat: 'Bidet Spray', src: 'bidet' }
  ];

  /* `cart` is a short noun phrase, not a sentence: it is shown as a cart line
     property and again at checkout. It also has to be present for
     snippets/trs-bundle-line-props.liquid to render a bundle line at all. */
  var BUILD = {
    cart: 'Vanity with insert basin',
    slots: [
      { k: 'toilet', cat: 'Toilet Bowl', src: 'toilet' },
      { k: 'vanity', cat: 'Vanity + Insert Basin', src: 'vanity' }
    ].concat(TAIL, ACC)
  };

  var picks = {}, active = null, shownSaving = 0;
  /* The build lives in memory, so opening a product page or an accidental reload
     would otherwise wipe eight choices. sessionStorage keeps it for the tab only. */
  var SAVE_KEY = 'trsbb:build:v2';
  var cache = {}, inflight = {};
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-SG'); };
  /* The theme upload path can mangle the newline after any line holding an odd
     number of double quotes, so the escaper builds its quote from a char code. */
  var QUOTE = String.fromCharCode(34);
  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  ESCAPES[QUOTE] = '&quot;';
  var ESC_RE = new RegExp('[&<>' + QUOTE + ']', 'g');
  var esc = function (s) {
    return String(s == null ? '' : s).replace(ESC_RE, function (c) { return ESCAPES[c]; });
  };

  /* Titles on this catalogue usually start with the vendor already, so blindly
     prefixing it produced things like SANITON | SANITON | VERONICA ST2977. */
  function labelFor(item) {
    var t = item.title || '', b = item.brand || '';
    if (!b) return t;
    var norm = function (x) { return x.toLowerCase().replace(/[^a-z0-9]/g, ''); };
    return norm(t).indexOf(norm(b)) === 0 ? t : b + ' · ' + t;
  }

  /* Every slot is inside the fixed price now that the paid add-on is gone, so a
     card always shows the compare-at (retail) figure the bundle is measured
     against, never a line price the customer would actually be charged. */
  function shownPrice(item) {
    return item.rrp;
  }

  function load(key) {
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    var handle = SRC[key], out = [], slotEx = 'bundle:exclude:' + key;
    var grab = function (page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          out = out.concat(list);
          if (list.length === 250 && page < 6) return grab(page + 1);
          return out;
        });
    };
    inflight[key] = grab(1).then(function (list) {
      cache[key] = list
        /* bundle:exclude keeps an item out of the builder entirely (spare parts,
           fittings). bundle:exclude:<slot> keeps it out of one slot only, which is
           how the cost-price caps on the tap and rainshower slots are applied. */
        .filter(function (p) {
          var tags = p.tags || [];
          return tags.indexOf('bundle:exclude') === -1 && tags.indexOf(slotEx) === -1;
        })
        .map(function (p) {
          var vs = p.variants || [], v = null, i;
          for (i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
          if (!v) v = vs[0];
          if (!v) return null;
          var price = parseFloat(v.price);
          var cmp = parseFloat(v.compare_at_price);
          return { id: v.id, title: p.title, brand: p.vendor || '',
            price: price,
            /* Fall back to price when compare-at is missing, zero, or below price. */
            rrp: (isFinite(cmp) && cmp > price) ? cmp : price,
            img: (p.images && p.images[0] && p.images[0].src) || '',
            url: p.handle ? '/products/' + p.handle : '',
            tags: p.tags || [] };
        })
        .filter(Boolean);
      delete inflight[key];
      return cache[key];
    });
    return inflight[key];
  }

  function slotArt() {
    return '<svg viewBox="0 0 48 48" fill="none" stroke="#B6A991" stroke-width="1.5" width="38" height="38">' +
      '<rect x="9" y="9" width="30" height="30" rx="3" stroke-dasharray="4 4"/>' +
      '<path d="M24 18v12M18 24h12"/></svg>';
  }

  function renderSlots() {
    $('trsbb-grid').innerHTML = BUILD.slots.map(function (s, i) {
      var p = picks[s.k], inner;
      if (p) {
        inner = '<div class="trsbb-thumb">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : slotArt()) + '</div>' +
          '<div class="trsbb-cat">' + esc(s.cat) + '</div>' +
          '<div class="trsbb-pick">' + esc(p.title) + '</div>' +
          '<div class="trsbb-acts"><button data-open="' + s.k + '">Change</button>' +
          '<button data-clear="' + s.k + '">Remove</button></div>';
      } else {
        inner = '<div class="trsbb-thumb">' + slotArt() + '</div>' +
          '<div class="trsbb-cat">' + esc(s.cat) + '</div>' +
          '<div class="trsbb-choose">+ Choose</div>';
      }
      return '<div class="trsbb-slot' + (p ? ' is-filled' : '') + '" data-slot="' + s.k + '">' +
        '<span class="n">' + (i + 1) + '</span>' + inner + '</div>';
    }).join('');

    updateTotals();
    saveBuild();
  }

  function countTo(el, to) {
    var from = shownSaving; shownSaving = to;
    var t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / 460), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  function updateTotals() {
    var slots = BUILD.slots, total = slots.length;
    var chosen = slots.filter(function (s) { return picks[s.k]; });
    var sum = chosen.reduce(function (a, s) { return a + picks[s.k].rrp; }, 0);
    var left = total - chosen.length, diff = sum - FIXED;

    $('trsbb-cnt').textContent = chosen.length;
    $('trsbb-tot').textContent = total;
    $('trsbb-fill').style.width = (chosen.length / total * 100) + '%';
    $('trsbb-remain').textContent = left ? left + ' to go' : 'Ready to add';
    $('trsbb-barwas').textContent = sum ? 'Individually ' + money(sum) : '';
    $('trsbb-barsave').textContent = diff > 0 ? 'You save ' + money(diff) : '';
    $('trsbb-atc').disabled = left > 0;
    $('trsbb-was').textContent = money(sum);

    var sv = $('trsbb-sv');
    sv.classList.toggle('is-empty', chosen.length === 0);
    sv.classList.toggle('is-locked', left === 0 && diff > 0);
    if (diff > 0) {
      countTo($('trsbb-svbig'), diff);
      $('trsbb-svpct').textContent = Math.round(diff / sum * 100) + '% off retail';
      $('trsbb-svsub').textContent = left === 0
        ? 'Locked in. One price, one line at checkout.'
        : left + ' more to go. The saving grows with every box.';
    } else {
      shownSaving = 0;
      $('trsbb-svbig').textContent = '$0';
      $('trsbb-svpct').textContent = '';
      $('trsbb-svsub').textContent = 'Your saving grows with every box you fill.';
    }
  }

  function slotFor(key) {
    return BUILD.slots.filter(function (s) { return s.k === key; })[0];
  }

  function openPicker(key) {
    active = key;
    var slot = slotFor(key);
    if (!slot) { active = null; return; }
    $('trsbb-shtitle').textContent = 'Choose your ' + slot.cat.replace(/ \d$/, '').toLowerCase();
    $('trsbb-shsub').textContent = 'Loading…';
    $('trsbb-q').value = '';
    $('trsbb-sort').value = 'rec';
    $('trsbb-pgrid').innerHTML = '<div class="trsbb-loading">Loading products…</div>';
    $('trsbb-ov').hidden = false;
    document.body.style.overflow = 'hidden';
    load(slot.src).then(function (list) {
      if (active !== key) return;
      $('trsbb-shsub').textContent = list.length
        ? list.length + ' products available'
        : 'Being added shortly';
      renderList();
    });
  }

  function closePicker() {
    $('trsbb-ov').hidden = true;
    document.body.style.overflow = '';
    active = null;
  }

  function renderList() {
    if (!active) return;
    var slot = slotFor(active);
    if (!slot) return;
    var list = cache[slot.src] || [];
    var q = $('trsbb-q').value.toLowerCase().trim(), so = $('trsbb-sort').value;

    var rows = list.map(function (it) {
      return { it: it, shown: shownPrice(it) };
    });
    if (q) rows = rows.filter(function (r) {
      return (r.it.title + ' ' + r.it.brand).toLowerCase().indexOf(q) > -1;
    });

    /* `rec` deliberately does not re-sort: the fetched order is the collection's own
       best-selling order, which beats cheapest-first as a default. */
    if (so === 'lo') rows.sort(function (a, b) { return a.shown - b.shown; });
    else if (so === 'hi') rows.sort(function (a, b) { return b.shown - a.shown; });
    else if (so === 'az') rows.sort(function (a, b) { return a.it.title.localeCompare(b.it.title); });

    if (!rows.length) {
      $('trsbb-pgrid').innerHTML = '<div class="trsbb-empty">' +
        (list.length
          ? 'No products match that search.'
          : 'We are adding these to the store shortly. Message us on WhatsApp if you want a hand in the meantime.') +
        '</div>';
      return;
    }

    var cur = picks[active];
    var html = '';
    rows.forEach(function (r) {
      var chosen = cur && cur.id === r.it.id, elsewhere = [];
      BUILD.slots.forEach(function (s) {
        if (s.k !== active && picks[s.k] && picks[s.k].id === r.it.id) elsewhere.push(s.cat);
      });
      var openTag = r.it.url
        ? '<a class="trsbb-plink" href="' + esc(r.it.url) + '" target="_blank" rel="noopener">'
        : '<div class="trsbb-plink">';
      var closeTag = r.it.url ? '</a>' : '</div>';
      html += '<div class="trsbb-card' + (chosen ? ' is-chosen' : '') + '">' +
        openTag +
        '<div class="trsbb-pimg">' + (r.it.img ? '<img src="' + esc(r.it.img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="trsbb-pbrand">' + esc(r.it.brand) + '</div>' +
        '<div class="trsbb-ptitle">' + esc(r.it.title) + '</div>' +
        (r.it.url ? '<span class="trsbb-pview">View details &#8599;</span>' : '') +
        closeTag +
        '<div class="trsbb-pprice">' + money(r.shown) + '</div>' +
        (elsewhere.length ? '<div class="trsbb-used">Already in ' + esc(elsewhere.join(', ')) + '</div>' : '') +
        '<button class="trsbb-sel" data-pick="' + r.it.id + '">' + (chosen ? '✓ Selected' : 'Select') + '</button>' +
        '</div>';
    });
    $('trsbb-pgrid').innerHTML = html;
  }

  /* Hands the updated cart to Dawn's drawer instead of navigating to /cart. We ask
     /cart/add.js for the rendered sections in the same round trip; the theme's global
     fetch hook (assets/cart-drawer.js) deliberately stands down when a response already
     carries `sections`, so the drawer is rendered here exactly once. */
  function openDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data || !data.sections || typeof drawer.renderContents !== 'function') {
      window.location.href = '/cart';
      return false;
    }
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.renderContents(data);
    return true;
  }

  function addToCart() {
    var slots = BUILD.slots;
    /* snippets/trs-bundle-line-props.liquid renders nothing unless the line carries
       a Bundle layout property, so this stays even though there is now one layout. */
    var props = { 'Bundle layout': BUILD.cart };
    slots.forEach(function (s) {
      var p = picks[s.k];
      if (p) {
        props[s.cat] = labelFor(p);
        props['_' + s.k + '_variant'] = String(p.id);
        /* Hidden, keyed off the visible property name so the cart template can pair a
           thumbnail to each pick without a variant lookup. */
        if (p.img) props['_img:' + s.cat] = p.img;
      }
    });
    var items = [{ id: Number(VARIANT), quantity: 1, properties: props }];

    var btn = $('trsbb-atc');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (data) {
      btn.removeAttribute('aria-busy');
      if (openDrawer(data)) updateTotals();
    })
    ['catch'](function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      alert('Something went wrong adding your bundle. Please try again, or message us on WhatsApp.');
    });
  }

  /* Chaty's WhatsApp bubble is fixed bottom-right at z-index 997, so it sat on top
     of the sticky CTA bar (z-index 40) — worst on mobile, where the bar is full
     width and the bubble covered the button text. Publishing the bar's measured
     height lets the stylesheet lift the bubble clear of it, whatever the bar's
     height happens to be on that viewport. */
  function syncBarHeight() {
    var bar = $('trsbb-bar');
    var h = bar && !bar.hidden ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--trsbb-bar-h', h + 'px');
  }

  function saveBuild() {
    try { sessionStorage.setItem(SAVE_KEY, JSON.stringify({ picks: picks })); }
    catch (e) {}
  }

  function loadBuild() {
    try { return JSON.parse(sessionStorage.getItem(SAVE_KEY) || 'null'); }
    catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open) { openPicker(open.dataset.open); return; }
    var clear = e.target.closest('[data-clear]');
    if (clear) {
      e.stopPropagation();
      delete picks[clear.dataset.clear];
      renderSlots();
      return;
    }
    var pick = e.target.closest('[data-pick]');
    if (pick) {
      var id = Number(pick.dataset.pick);
      var slot = slotFor(active);
      if (!slot) return;
      var item = (cache[slot.src] || []).filter(function (x) { return x.id === id; })[0];
      if (item) {
        picks[active] = item;
        renderSlots();
        closePicker();
      }
      return;
    }
    var slotEl = e.target.closest('[data-slot]');
    if (slotEl && !e.target.closest('button')) { openPicker(slotEl.dataset.slot); return; }
    if (e.target === $('trsbb-ov')) closePicker();
  });

  $('trsbb-shx').addEventListener('click', closePicker);
  $('trsbb-q').addEventListener('input', renderList);
  $('trsbb-sort').addEventListener('change', renderList);
  $('trsbb-atc').addEventListener('click', addToCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !$('trsbb-ov').hidden) closePicker();
  });

  /* There is one layout, so the boxes are live from first paint with nothing to
     choose first. A saved build is restored on the way in, which is what makes
     opening a product page and coming back safe. */
  var saved = loadBuild();
  if (saved) picks = saved.picks || {};
  $('trsbb-build').hidden = false;
  $('trsbb-savings').hidden = false;
  $('trsbb-bar').hidden = false;
  renderSlots();

  syncBarHeight();
  window.addEventListener('resize', syncBarHeight);
  window.addEventListener('orientationchange', syncBarHeight);
  if (window.ResizeObserver) new ResizeObserver(syncBarHeight).observe($('trsbb-bar'));
})();
